import { FirebaseOptions } from '../types';

export const config: FirebaseOptions = {
  apiKey: 'AIzaSyDEs6Z1ofqgGOurC-nxaWwvofmRlY0AIyc',
  authDomain: 'livetracker-prod.firebaseapp.com',
  projectId: 'livetracker-prod',
  storageBucket: 'livetracker-prod.appspot.com',
  messagingSenderId: '906774058681',
  appId: '1:906774058681:web:ef906e3d1af8c340fa6d68',
  measurementId: "G-ZJG8S69LL1"
};
